import EventBus from "@/eventBus";
import router from "@/router";
import { AI_AGENTS } from "@/constants/constantsValues";

var socket = null;
 const contactobj = (response)=>{
  const contact = {
    id: 0,// it will update in default display
    type: "contact",
    fullName:
      (response.first_name || "") +
      (response.first_name && response.last_name
        ? ` ${response.last_name}`
        : ""),
    ph1: response.ph1,
    ph2: response.ph2,
    ph3: response.ph3,
    email: response.email,
    contact_id : response.contact_id,
    OD_PatNum: response.OD_PatNum,
  };
  return contact;
}


function socketOnOpen() {
  console.info("socket opened", socket);
}

function socketOnError(error) {
  console.error(error);
  EventBus.$emit("alert", "Error connecting to server");
}

function socketOnMessage(message, store) {
  let m = JSON.parse(message.data);
  // m.type is the message type
  // m.message is the message
  console.log("LOG M IN SOCKET ",m);
  console.log(m.type);
  switch (m.type) {
    case "AI_Contact_Info":
      store.commit("openAI/upsertPatientInfo", m.message);
      break;
    case "Appointment_Request":
      try{
        console.log("Appointment Request received:", m.message);
        store.commit('openAI/setCalendarIntent', { type: 'OD', date: m.message });
        router.push({ path: "/calendar" });
      } catch (error) {
        console.error("Error processing Appointment Request:", error);
      }
      break;
    // Here are the cases involving the Plivo module.
    // --------------------------------------------------------------------------------
    case "addOrUpdateConference":
      store.commit("plivo/addOrUpdateConference", m.message);
      break;
    case "removeConference":
      store.dispatch("plivo/removeConferenceAndStoreAIInfo", m.message);
      break;
    case "updateUserDictionary":
      store.dispatch("plivo/updateUserDictionary", m.message);
      break;
    // Here are cases involving the convos module
    // --------------------------------------------------------------------------------
    case "addMessage":
      
      // Get current conversation from the getter instead of direct state access
      const currentConvo = store.state.convos.convos[m.message.convo_id];
      
      if (currentConvo?.convo_name === AI_AGENTS.AI_ANALYTICAL && currentConvo.convo_participants?.some(participant => participant.user_id === store.getters.userId)) {
        //Setting aiLoading to false for AI Analytical conversation
        store.commit("osclaims/changeAiLoading", false);
      }

      store.commit("convos/addMessage", {
        convo_id: m.message.convo_id,
        message: m.message,
        user_id: store.getters.userId,
      });

      // If the message contains a video call link, fetch room status + recordings in parallel
      store.dispatch("video/fetchVideoCallData", m.message);
      break;
    case "addConvo":
      // add the new convo to the convos state
      store.commit("convos/addNewConvo", {
        convo: m.message.convo,
        user_id: store.getters.userId,
      });
      // add the new convo to its corresponding system process
      if (m.message.system_object.system_process === "outstanding claim")
        store.commit("osclaims/addConvo", {
          convo: m.message.convo,
          DSSClaimsID: m.message.system_object.system_process_id,
        });
      else if (m.message.system_object.system_process === "recall")
        store.commit("recall/addConvo", {
          convo: m.message.convo,
          DSSRecallID: m.message.system_object.system_process_id,
        });

      break;
    case "updateConvoStatus":
      store.commit("convos/updateConvoStatus", m.message);
      break;

case "addParticipant": 
  const Participantmsg = m.message;
  const ThreadParticipant = store.state.threadconvo.allthreadconvos
    .some(t => t.convo_thread?.convo_id === Participantmsg.convo_id);

  if (ThreadParticipant) {
    store.commit("threadconvo/ADD_THREAD_PARTICIPANT", Participantmsg);
  } else {
    store.commit("convos/addParticipant", Participantmsg);
  }
  break;
  case "deleteParticipant":
      store.commit("convos/deleteParticipant", m.message);
      break;
    case "addReminder":
      m.message.forUser =
        m.message.reminder.reminder_for_who === store.getters.userId;
      store.commit("convos/addReminder", m.message);
      break;
    case "deleteReminder":
      m.message.forUser = m.message.reminder_for_who === store.getters.userId;
      store.commit("convos/deleteReminder", m.message);
      break;
    case "updateReminder":
      m.message.forUser = m.message.reminder_for_who === store.getters.userId;
      store.commit("convos/updateReminder", m.message);
      break;
    case "reminderDue":
      if (m.message && m.message.length > 0) {
        // Enrich with any already-known contact fields (ph2/ph3/email/etc.) the same
        // way addMissedCall does, since the backend push only carries the minimal
        // fields resolved via the convos -> convo_references -> contacts bridge.
        const contacts = store.getters["people/contactsHash"] || {};
        const contact = contacts[parseInt(m.message[0].contact_id)];
        if (contact) {
          m.message[0] = { ...contact, ...m.message[0] };
        }
      }
      store.commit("frontdesk/reminderDue", m.message);
      break;
    case "reminderResolved":
      // Aggregate check already happened server-side (convo.controller.js) — this only
      // fires once no *other* due reminder remains for the contact, so it's always safe
      // to just clear the badge here.
      store.commit("frontdesk/reminderResolved", m.message);
      break;
    case "addConversationTag":
    case "removeConversationTag":
      // Conversation tags previously never broadcast at all (unlike contact tags) — a
      // tag add/remove only became visible to other staff after a reload. Mirror the
      // in-place array mutation FDMessage.vue's own applyTag/removeTag already do
      // locally, but against the shared frontdesk/allConversations state so every
      // connected client sees it live, not just the one that clicked.
      store.commit(
        m.type === "addConversationTag" ? "frontdesk/addConversationTagLive" : "frontdesk/removeConversationTagLive",
        m.message
      );
      // Also keep the "Unattended" left-panel filter list live — the payload now
      // carries contact_id (and, on remove, contact_still_tagged) so this can
      // live-patch left_panel_contacts without a follow-up fetch. Filtered here
      // (not in the mutation) so moduleFrontDesk.js doesn't need to know about
      // specific tag names.
      if (m.message && (store.getters["tags/tagsHash"] || {})[m.message.tag_id] === "Unattended") {
        store.commit(
          m.type === "addConversationTag" ? "frontdesk/unattendedTagAddedLive" : "frontdesk/unattendedTagRemovedLive",
          m.message
        );
      }
      break;
    case "completeMention":
      m.message.forUser = m.message.user_id === store.getters.userId;
      store.commit("convos/completeMention", m.message);
      break;
    case "addMissedCall":
      if (m.message && m.message.length > 0) {
        //Adding the contact details to received messages to persist the left panel phone icons
        if (m.message[0].isContact) {

          let contacts = store.getters["people/contactsHash"] || {};
          let contact = contacts[parseInt(m.message[0].contact_id)];

      if (contact) {
          m.message[0]["ph1"] = contact.ph1;
          m.message[0]["ph2"] = contact.ph2;
          m.message[0]["ph3"] = contact.ph3;
          m.message[0]["email"] = contact.email;
          m.message[0]["textable1"] = contact.textable1;
          m.message[0]["textable2"] = contact.textable2;
          m.message[0]["textable3"] = contact.textable3;
    }

      const typeHash = store.getters["people/contactTypes"] || [];
          for (let type of typeHash) {
            if (type.type_id == m.message[0]["contact_type"]) {
              m.message[0]["typeName"] = type.type_name;
              break;
            }
          }

        } else {
          m.message[0]["phone_num"] = m.message[0].contact_id;
        }
        let conversationtag =store.state.frontdesk.conversationtag || [];

             const matched = store.state.frontdesk.odDataHash?.[m.message[0].contact_id];

    if (m.message[0].conversationstags && m.message[0].conversationstags.length > 0) {
      if(!matched){

        store.commit("frontdesk/append_odData", [m.message[0]]);

        let append_odData = {};
        append_odData[m.message[0].contact_id] = true;

        store.commit("frontdesk/append_odDataHash", append_odData);

        store.commit("frontdesk/addNewconversationtag", {
          contact_id: m.message[0].contact_id,
          tags: {
            conversation_id: m.message[0].comm_participant_id,
            tags: m.message[0].tags,
            timestamp: m.message[0].timestamp
          }
        });

      }else if(conversationtag && conversationtag.length != 0){
        const tags1 = m.message?.[0]?.tags || [];
      const tags2 = conversationtag?.[0]?.tags || [];

        const hasCommonTag = tags1.some(tag => tags2.includes(tag));

        if (hasCommonTag) {
          store.commit("frontdesk/addNewconversationtag", {
            contact_id: m.message[0].contact_id,
            tags: {
              conversation_id: m.message[0].comm_participant_id,
              tags: m.message[0].tags,
              timestamp: m.message[0].timestamp
            }
          });
        }
      }
    }

    if (conversationtag.length > 0) {
      store.commit("frontdesk/set_left_panel_contacts", store.state.frontdesk.odData);
    }

    // fd_contacts handled inside mutation
    store.commit("frontdesk/addNewCall", m.message);
    store.commit("frontdesk/callDetails", m.message);
  }
  break;
    // Contact Related
    case "contact":
      if (m.message && m.message.length > 0) {
        //Adding the contact details to received messages to persist the left panel phone icons
        //let contacts = store.getters['people/contacts']
        //let contact = contacts.find(o => o.contact_id === parseInt(m.message[0].contact_id))
        console.log("after saving contact:" + m.message);
        store.commit("people/add_update_contacts", m.message[0]);
        store.commit("frontdesk/updateContactDetails", m.message);

        EventBus.$emit("updateSearchML", {
          contact: contactobj(m.message[0]),
          type: "add",
        });
      }
      break;
    case "setContactType":
      store.commit("people/add_update_contacts", m.message);
      store.dispatch("frontdesk/update_contactTypesdata", m.message, {
        root: true,
      }); //all_contact_types_data
      break;
    case "updateContact":
      store.commit("people/add_update_contacts", m.message[0]);
      store.commit("frontdesk/updateContactDetails", m.message);
      store.dispatch("people/updateSearchML", {
        contact: contactobj(m.message[0]),
        type: "edit",
      })
      break;
    case "deleteContact":
      store.dispatch("people/updateSearchML", {
        contact: parseInt(m.message),
        type: "delete",
      });
      store.commit("people/delete_contact", parseInt(m.message));
      break;
    case "createContactType":
      store.commit("people/add_ContacTypes", m.message);
      break;
    case "updateContactType":
      store.commit("people/update_ContactTypes", m.message);
      break;
    case "addInternalMessage":
        const remainderThread = store.state.threadconvo.allthreadconvos
    .some(t => t.convo_thread?.convo_id === m.message.convo_id);

      if(remainderThread){
       store.commit("threadconvo/ADD_THREAD_MESSAGE", {
    convo_id:m.message.convo_id,
    message: m.message
  });
  EventBus.$emit("internal-thread-updated")
      }else{
              store.commit("convos/addInternalMessage", {
        convo_id: m.message.convo_id,
        message: m.message,
        user_id: store.getters.userId,
      });
      }

      break;
    case "addInternalConvo":
      m.message.convo.contact_id = parseInt(m.message.convo.contact_id);
      store.commit("convos/addInternalConvo", { ...m.message.convo });
      if(m.message?.convo.convo_references[0]?.conversation){
        store.commit("frontdesk/update_convo_count", {
        conversation_id:
          m.message?.convo.convo_references[0]?.conversation?.conversation_id,
        count: 1,
      });
      }
      break;
   case "completeInternalMention":
  const threadmsg = m.message;
  const ThreadMention = store.state.threadconvo.threadMessages[String(threadmsg.convo_id)] !== undefined;

  threadmsg.forUser = threadmsg.user_id === store.getters.userId;

  if (ThreadMention) {
    store.commit("threadconvo/COMPLETE_THREAD_MENTION", threadmsg);
  } else {
    store.commit("convos/completeInternalMention", threadmsg);
  }
  break;

case "addInternalReminder": 
  const isThread = store.state.threadconvo.allthreadconvos
    .some(t => t.convo_thread?.convo_id === m.message.convo_id);

  if (isThread) {
    store.commit("threadconvo/ADD_THREAD_REMINDER", m.message);
  } else {
    m.message.forUser = m.message.reminder_for_who === store.getters.userId;
    store.commit("convos/addInternalReminder", m.message);
  }
  break;
case "updateInternalReminder":
  const updateThreadReminder = store.state.threadconvo.allthreadconvos
    .some(t => t.convo_thread?.convo_id === m.message.convo_id);

  if (updateThreadReminder) {
    store.commit("threadconvo/UPDATE_THREAD_REMINDER", m.message);
  } else {
    m.message.forUser = m.message.reminder_for_who === store.getters.userId;
    store.commit("convos/updateInternalReminder", m.message);
  }
  break;

  case "deleteInternalReminder":
  m.message.forUser = m.message.reminder_for_who === store.getters.userId;

  // If the reminder belongs to a thread/internal convo → update threadconvo module
  if (m.message.process === "thread_internal" || m.message.internal_convo_id) {
    store.commit("threadconvo/DELETE_THREAD_REMINDER", m.message);
  } 
  else {
    store.commit("convos/deleteInternalReminder", m.message);
  }

  break;
 case "deleteInternalConvo":
      m.message.internal_convo_id = parseInt(m.message.internal_convo_id);
      store.commit("convos/deleteInternalConvo", m.message);
      break;
    case "subscription_details":
      store.commit("user", m.message);
      break;
    // Here are cases involving the tags module
    // -------------------------------------------------------------
    case "update_tags":
      store.commit("tags/update_Tag", m.message); // add and update
      break;
    case "deleteTag":
      store.commit("tags/delete_Tag", parseInt(m.message));
      break;
    case "addTagsToContact":
      store.dispatch("frontdesk/add_contactTagsdata", m.message);
      break;
    case "removeTagForContact":
      store.dispatch("frontdesk/remove_contactTagsdata", m.message);
      break;
    case "addTagsToOsClaims":
      EventBus.$emit("addTagsToOsClaims", m.message);
      break;
    case "removeTagForOsClaims":
      EventBus.$emit("removeTagForOsClaims", m.message);
      break;
    // Here are cases involving the frontdesk module
    // --------------------------------------------------------------------------------

    case "newEmail":{
      const newEmailObj = m.message.newEmail[0];
      const contact_id = newEmailObj.contact_id;
      let calls = store.getters["frontdesk/fd_contacts"] || [];
      let contact = calls.find((o) => parseInt(o.contact_id) === contact_id);

      if (!contact) {
        console.warn("Contact not found for contact_id:", contact_id);
        break;
      }

      // Merge all fields from newEmailObj and contact
      let message = [
        {
          ...newEmailObj,
          message: newEmailObj.snippet,
          call_status: contact.call_status,
          email: contact.email,
          first_name: contact.first_name,
          isContact: contact.isContact,
          last_name: contact.last_name,
          ph1: contact.ph1,
          ph2: contact.ph2,
          ph3: contact.ph3,
          seqId: contact.seqId,
          textable1: contact.textable1,
          textable2: contact.textable2,
          textable3: contact.textable3
          
        },
      ];
       let conversationtag =store.state.frontdesk.conversationtag;
             const matched = store.state.frontdesk.odDataHash?.[contact_id];
      if (message[0].conversationstags && message[0].conversationstags.length > 0) {
        if(!matched){
             store.commit("frontdesk/append_odData",message);
             let append_odData ={};
             append_odData[contact_id]=true;
             store.commit("frontdesk/append_odDataHash",append_odData);
             store.commit("frontdesk/addNewconversationtag",{contact_id: contact_id, tags:{conversation_id: message[0].comm_participant_id, tags: message[0].tags, timestamp: message[0].timestamp}});
        }else if(conversationtag && conversationtag.length != 0){
          const tags1 = message?.[0]?.tags || [];
        const tags2 = conversationtag?.[0]?.tags || [];

        const hasCommonTag = tags1.some(tag => tags2.includes(tag));

        if (hasCommonTag) {
          store.commit("frontdesk/addNewconversationtag",{contact_id: contact_id, tags:{conversation_id: message[0].comm_participant_id, tags: message[0].tags, timestamp: message[0].timestamp}});
          }
       }
      }

      if (conversationtag.length > 0) {
        store.commit("frontdesk/set_left_panel_contacts", store.state.frontdesk.odData);
      }

      store.commit("frontdesk/addNewCall", message);
      store.commit("frontdesk/callDetails", message);
      break;
    }

    case "newTextMessage": {
      const newTextMessageObj = m.message.newTextMessage[0];
      const contact_id = newTextMessageObj.contact_id;
      let calls = store.getters["frontdesk/fd_contacts"] || [];
      let contact = calls.find((o) => parseInt(o.contact_id) === contact_id);

      if (!contact) {
        console.warn("Contact not found for contact_id:", contact_id);
        break;
      }

      let message = [
        {
          ...newTextMessageObj,
          call_status: contact.call_status,
          email: contact.email,
          first_name: contact.first_name,
          isContact: contact.isContact,
          last_name: contact.last_name,
          ph1: contact.ph1,
          ph2: contact.ph2,
          ph3: contact.ph3,
          seqId: contact.seqId,
          textable1: contact.textable1,
          textable2: contact.textable2,
          textable3: contact.textable3,
        },
      ];

      store.commit("frontdesk/addNewCall", message);
      store.commit("frontdesk/callDetails", message);
      break;
    }
    case "emailFetchProgress":
      store.commit("setEmailFetchProgress", m.message);
      break;

    case "emailSyncStatus":
      EventBus.$emit("emailSyncStatusUpdate", m.message);
      break;
    case "importedContactEmailFetchProgress":
      store.commit("setEmailFetchProgressContact", m.message);
      break;
    case "failedJobsCount":
      store.commit("taskengine/setFailedJobs", m.message.count);
      break;
    case "te_job_updated":
      EventBus.$emit("te_job_updated", m.message);
      break;
    //-------------------------Message Template----------------------------------------

    case "createMessageTemplate":
      store.commit("frontdesk/add_message_template", m.message);
      break;
    case "updateMessageTemplate":
      store.commit("frontdesk/update_message_template", m.message);
      break;
    case "deleteMessageTemplate":
      store.commit("frontdesk/delete_message_template", m.message);
      break;
    //-------------------------Calendar----------------------------------------
      case "addCalendar":
        store.commit("calendar/addCalendar", m.message);
        break;
      case "updateCalendar":
        store.commit("calendar/updateCalendar", m.message);
        break;
      case "addCalendarMember":
        store.commit("calendar/addCalendarMember", m.message);
        break;
      case "updateCalendarMemberRole":
        store.commit("calendar/updateCalendarMemberRole", m.message);
        break;
      case "removeCalendarMember":
        store.commit("calendar/removeCalendarMember", m.message);
        if(m.message.user_id == store.getters.userId){
          store.commit("calendar/currentCalendar", {});
        }
        break;
      case "addCalendarEvent":
        store.dispatch("calendar/addCalendarEvent", m.message)
        break;
      case "updateCalendarEvent":
        store.dispatch("calendar/updateCalendarEvent", m.message)
        break;
      case "deleteCalendarEvent":
        store.commit("calendar/removeEvent", m.message)
        break;
    //-----------------------------thread covnvos----------------------------------
         case "addThreadConvo":
  const convo = m.message.convo;
        let msg = m.message.message;
        if (msg) {
          msg.system_process = "thread_internal";
        }

  store.commit("threadconvo/ADD_CONVO", convo);

  if (msg && (msg.convo_message_id || msg.id)) {
    const normalizedMessage = {
      convo_message_id: msg.convo_message_id ?? msg.id ?? `tmp-${Date.now()}`,
      convo_id: convo.convo_id,
      message: msg.message ?? "",
      who_sent: msg.who_sent ?? msg.user_id ?? null,
      date: msg.date ?? new Date().toISOString(),
      convo_mentions: Array.isArray(msg.convo_mentions) ? msg.convo_mentions : [],
      convo_attachments: msg.convo_attachments ?? msg.attachments ?? [],
      ref: msg.ref ?? null,
      system_process: msg.system_process,
      _raw: msg
    };

    store.commit("threadconvo/ADD_THREAD_MESSAGE", {
      convoId: convo.convo_id,
      message: normalizedMessage
    });
  }

  if (m.message.parent_message_id) {
    store.commit("convos/addThreadConvoToMessage", {
      parent_message_id: m.message.parent_message_id,
      threadData: {
        convo_thread_id: convo.convo_id,
        convo_thread: {
          convo_id:           convo.convo_id,
          system_process:     convo.system_process ?? "thread_internal",
          messages_updated_at: convo.messages_updated_at ?? null
        }
      }
    });
  }
  EventBus.$emit("internal-thread-updated");
  break;
case "addInternalthreadMessage": {
  const raw = m.message;

  const convoId = Number(raw.convo_id);
  const key = String(convoId);

  const openId = Number(store.state.threadconvo.convo?.convo_id);
  const threadMsgs = store.state.threadconvo.threadMessages[key];
  const normalizedMessage = {
    convo_message_id: raw.convo_message_id || raw.id || Date.now(),
    convo_id: convoId,
    message: raw.message || "",
    who_sent: raw.who_sent || raw.user_id || null,
    date: raw.date || new Date().toISOString(),
    convo_mentions: Array.isArray(raw.convo_mentions) ? raw.convo_mentions : [],
    convo_attachments: raw.convo_attachments || raw.attachments || [],
    ref: raw.ref || null,
    _raw: raw
  };
const isKnownThread = store.state.threadconvo.allthreadconvos
  .some(t => t.convo_thread?.convo_id === convoId);

if (!threadMsgs && openId !== convoId && !isKnownThread) {
  break;
}
  store.commit("threadconvo/ADD_THREAD_MESSAGE", {
    convoId,
    message: normalizedMessage
  });
  EventBus.$emit("internal-thread-updated");

  break;
}

    //---------------------------------------------------------------
    case "addParticipantInitiated":
      store.commit("plivo/addParticipantStatusEvent", { type: "Initiated", data: m.message });
      break;
    case "addParticipantRinging":
      store.commit("plivo/addParticipantStatusEvent", { type: "Ringing", data: m.message });
      break;
    case "participantAnswered":
      store.commit("plivo/addParticipantStatusEvent", { type: "Answered", data: m.message });
      break;
    case "participantHangup":
      store.commit("plivo/addParticipantStatusEvent", { type: "Hangup", data: m.message });
      break;
    case "updateOngoingCalls":
      store.commit("plivo/setOngoingCalls", m.message);
      break;
    case "videoGuestRequest":
      // Patient has requested to join a video call — add to waiting guests and alert admin
      store.commit('video/ADD_WAITING_GUEST', {
        identity: m.message.identity,
        name: m.message.displayName,
      });
      EventBus.$emit('videoGuestRequest', m.message);
      break;
    case "videoMeetingEnded":
      EventBus.$emit('videoMeetingEnded', m.message);
      break;
    case "videoParticipantUpdate":
      EventBus.$emit('videoParticipantUpdate', m.message);
      break;
    default:
      console.error("Socket message type " + message.type + "not recognized",m);
      
  }
}

function openConnection(store) {
  // don't do anything if the connection is opening or already open
  if (socket && (socket.readyState === 0 || socket.readyState === 1)) return;

  // don't do anything if the user is logged out
  if (!store.state.validUser) return;

  if (socket) console.error("Websocket Disconnected");

  // open the websocket connection
  const wsUrl = process.env.VUE_APP_WS_URL || `${window.location.protocol === 'https:' ? 'wss' : 'ws'}://${window.location.host}`;
  socket = new WebSocket(wsUrl);

  socket.onopen = () => socketOnOpen();
  socket.onclose = () => openConnection(store);
  socket.onerror = (error) => socketOnError(error);
  socket.onmessage = (message) => socketOnMessage(message, store);
}

export default function createSocketPlugin() {
  return (store) => {
    // if the user is aleady logged in, open the connection
    if (store.state.validUser) openConnection(store);

    // subscribe to all actions
    store.subscribeAction({
      after: (action, state) => {
        if (action.type === "logIn" && state.user) {
          openConnection(store, state);
        } else if (action.type === "logOut") {
          if (socket) socket.close();
          socket = null;
        }
      },
    });
  };
}
